export const MY_ACCOUNT_PHONE_NUMBER = 'PHONE_NUMBER';
export const MY_ACCOUNT_UPDATE_USER = 'UPDATE_USER'
